import { useCallback, useEffect, useRef } from 'react';

export function useOnElementEntersView(callback: (el: Element) => void, threshold = 1, once = false) {
	const nodeRef = useRef<HTMLElement>();
	const handleInstersection = useCallback(
		(entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					callback(entry.target);
					if (once) {
						observer.disconnect();
					}
					break;
				}
			}
		},
		[callback, once]
	);
	useEffect(() => {
		const observer = new IntersectionObserver(handleInstersection, { threshold, rootMargin: '0px' });
		if (nodeRef.current) {
			observer.observe(nodeRef.current);
		}
		return () => {
			observer.disconnect();
		};
	}, [handleInstersection, threshold]);
	return useCallback((el?: HTMLElement | null) => {
		if (el) {
			nodeRef.current = el;
		}
	}, []);
}
